import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {FulfillmentStatus} from './FulfillmentConstants';
import {getIconAndClassNameForStatus} from './FulfillmentStatus';

export default function FulfillmentStatusIndicator({
  className,
  status,
}: {
  className?: string;
  status: FulfillmentStatus;
}): JSX.Element {
  const {icon, className: iconClassName} = getIconAndClassNameForStatus(status);
  return <BenchlingIcon className={classNames(className, iconClassName)} icon={icon} />;
}
FulfillmentStatusIndicator.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf(Object.values(FulfillmentStatus)).isRequired,
};
